<template>
  <div class="edit-box">
    <div class="edit-box-header">
      <h3 class="edit-box-title">{{ name }}</h3>
      <div class="edit-box-style" v-if="styleList && styleList.length">
        <el-select v-model="localStyle" placeholder="请选择样式" size="small">
          <el-option v-for="(item, index) in styleList" :key="index" :label="item.name" :value="item.value"></el-option>
        </el-select>
      </div>
    </div>

    <div class="edit-box-tip" v-if="tip">
      {{ tip }}
    </div>

    <div class="edit-box-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import editMixin from '../mixins/editMixin';

export default {
  name: 'EditBox',
  mixins: [editMixin],
  props: {
    name: {
      type: String,
      default: ''
    },
    styleList: {
      type: Array,
      default: () => []
    },
    currentStyle: {
      type: String,
      default: ''
    },
    tip: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.edit-box {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  border: 1px solid #e4e7ed;
  overflow-y: auto;

  .edit-box-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    border-bottom: 1px solid #f0f0f0;

    .edit-box-title {
      margin: 0;
      font-size: 16px;
      font-weight: 600;
      color: #303133;
    }

    .edit-box-style {
      .el-select {
        width: 100%;
      }
    }
  }

  .edit-box-tip {
    font-size: 12px;
    color: #606266;
    margin: 8px 16px;
    padding: 8px 12px;
    background: #ecf5ff;
    border-radius: 4px;
    border-left: 4px solid #409eff;
  }

  .edit-box-content {
    padding: 12px 16px;
    width: 100%;

    ul {
      list-style: none;
    }
  }
}
</style>
